import { createRequestTypes } from '../utils';

export const CPSR_CHAPTER_LIST = createRequestTypes('cpsrChapters/LIST_CHAPTERS');
